import { useEffect } from "react";

import { useRouter } from "next/router";

import { ContainerLoader } from "@/components/Loaders/ContainerLoader";
import { useCurrentUserContext } from "@/contexts/CurrentUserContext";

export const RedirectToLoginOnForbiddenGhostUserPage = ({
  children,
  allowGhostUsers,
}: {
  children: React.ReactNode;
  allowGhostUsers: boolean;
}) => {
  const { currentUser, userIsLoading } = useCurrentUserContext();
  const router = useRouter();

  // Redirect ghost users to complete signup if not allowed
  useEffect(() => {
    if (
      !userIsLoading &&
      currentUser &&
      currentUser.isGhostUser &&
      !allowGhostUsers &&
      router.pathname !== "/register"
    ) {
      router.push("/register");
    }
  }, [userIsLoading, currentUser, allowGhostUsers, router]);

  if (!allowGhostUsers && userIsLoading) {
    return <ContainerLoader fullPage />;
  }

  return <>{children}</>;
};
